var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c(
      "div",
      { staticClass: "map-container" },
      [
        _vm.divId
          ? _c("SelectOrdersMap", {
              attrs: { divisionId: _vm.divId, noAction: 1 },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.markers, function (marker) {
          return false
            ? [
                _c(
                  "ymap-marker",
                  {
                    attrs: {
                      "marker-id": marker.id,
                      "marker-type": "Placemark",
                      options: { draggable: true },
                      coords: marker.extra_options.geo_coordinates.coords,
                      icon: { color: "green", content: marker.line_order },
                    },
                    on: {
                      click: (e) => _vm.openOrder(e, marker.id),
                      dragend: (e) => _vm.updateCoords(e, marker.id),
                    },
                  },
                  [
                    _c("div", { attrs: { slot: "balloon" }, slot: "balloon" }, [
                      _c(
                        "div",
                        {
                          staticClass: "balloon_div",
                          attrs: { id: `balloon_div_${marker.id}` },
                        },
                        [
                          _c("p", [
                            _vm._v("Заявка: "),
                            _c("strong", [
                              _vm._v(_vm._s(("" + marker.id).substr(-4))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [_vm._v("Адрес: " + _vm._s(marker.address))]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {},
                            [
                              _c(
                                "div",
                                { staticClass: "input-group mb-3 mt-2" },
                                [
                                  _c("input", {
                                    ref: `newLineNum_${marker.id}`,
                                    refInFor: true,
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "number",
                                      "data-orderId": marker.id,
                                      placeholder: "Номер по списку",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("LoadingButton", {
                                    attrs: {
                                      title: "Сохранить номер",
                                      className:
                                        "btn btn-outline-success btn_line_number",
                                      loading: _vm.btnLoading,
                                      onClick: () =>
                                        _vm.updateOrder(
                                          marker.id,
                                          "line_number"
                                        ),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("LoadingButton", {
                                attrs: {
                                  title: "Сохранить текущую позицию",
                                  className:
                                    "btn btn-outline-info w-100 btn_geo_position",
                                  loading: _vm.btnLoading,
                                  onClick: () =>
                                    _vm.updateOrder(marker.id, "geo_position"),
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            : _vm._e()
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }